"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _XYFrame = require("./XYFrame");

var _XYFrame2 = _interopRequireDefault(_XYFrame);

var _OrdinalFrame = require("./OrdinalFrame");

var _OrdinalFrame2 = _interopRequireDefault(_OrdinalFrame);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (props) {
  if (props.frameType === "orFrame") {
    return _react2.default.createElement(_OrdinalFrame2.default, _extends({}, props, {
      oAccessor: props.xAccessor,
      rAccessor: props.yAccessor,
      data: props.pieceData,
      groupData: props.aggData,
      groupDataAccessor: props.aggDataAccessor,
      dataAccessor: props.pieceDataAccessor,
      groupType: props.customAggType,
      groupStyle: props.aggStyle,
      style: props.pieceStyle,
      type: props.customPieceType
    }));
  }
  return _react2.default.createElement(_XYFrame2.default, _extends({}, props, {
    points: props.pieceData,
    lines: props.aggData,
    lineDataAccessor: props.aggDataAccessor,
    pointDataAccessor: props.pieceDataAccessor,
    lineType: props.customAggType,
    lineStyle: props.aggStyle,
    pointStyle: props.pieceStyle
  }));
};

module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/semiotic/lib/SmartFrame.js
// module id = 249
// module chunks = 0